import classNames from 'classnames';

import { Text } from '@sravni/react-design-system/lib/Typography';

import styles from './FullDealEntryPointDisclaimer.module.scss';

export function FullDealEntryPointDisclaimer({ className, link: _ }: { className: string; link: string }) {
  return (
    <Text className={classNames(styles.disclaimer, className)}>
      При условии полного погашения задолженности на 21 день пользования займом
    </Text>
  );

  // return (
  //   <Text className={classNames(styles.disclaimer, className)}>
  //     Первый заём бесплатно при возврате в срок.{UNBREAKABLE_SEPARATOR}
  //     <a onClick={handleClick}>Подробнее</a>
  //   </Text>
  // );
}
